import type {Optional} from '@logistics-frontend/types'
import {get} from '@logistics-frontend/utils'
import type {SuggestLocation} from '@yandex-delivery/api/model/suggest'

type PointWithCoordinates = {
  latitude?: number
  longitude?: number
}

export const getPointCoordinates = <T extends PointWithCoordinates>(point?: T): Optional<SuggestLocation> => {
  const latitude = get('latitude', point)
  const longitude = get('longitude', point)

  if (latitude && longitude) {
    return [longitude, latitude]
  }

  return undefined
}
